import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/context/StoreContext";
import { imgSrc, money, RARITY } from "@/lib/api";

export const ProductCard = ({ p, cat, i = 0 }) => {
  const { add, currency, priceOf } = useStore();
  const soldOut = p.stock !== null && p.stock !== undefined && p.stock <= 0;
  const r = RARITY[p.rarity] || RARITY.comum;
  return (
    <div className="group rise rounded-2xl bg-[#111827] border border-white/10 overflow-hidden hover:border-violet-500/50 hover:-translate-y-1 transition-[transform,border-color] duration-300"
      style={{ animationDelay: `${i * 60}ms` }} data-testid={`product-card-${p.id}`}>
      <Link to={`/produto/${p.id}`} className="block relative aspect-[4/3] overflow-hidden" data-testid={`product-link-${p.id}`}>
        <img src={imgSrc(p.image)} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#111827] via-transparent to-transparent" />
        <span className="absolute top-3 left-3 rounded bg-[#0B0F19]/85"><span className={`block text-[10px] uppercase tracking-widest font-semibold px-2 py-1 rounded border ${r.cls}`}>{r.label}</span></span>
        {soldOut && <span className="absolute top-3 right-3 text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded bg-rose-600 text-white">Esgotado</span>}
      </Link>
      <div className="p-4">
        {cat && <p className="text-[10px] uppercase tracking-widest font-semibold" style={{ color: cat.color }}>{cat.name}</p>}
        <h3 className="font-heading font-bold text-base mt-1 line-clamp-1">{p.name}</h3>
        <div className="flex items-center justify-between mt-4">
          <span className="font-mono font-bold text-lg" data-testid={`product-price-${p.id}`}>{money(priceOf(p), currency)}</span>
          <button
            disabled={soldOut}
            onClick={() => { add(p); toast.success(`${p.name} adicionado ao carrinho`); }}
            data-testid={`add-to-cart-button-${p.id}`}
            className="h-9 w-9 rounded-full bg-violet-600 hover:bg-violet-500 disabled:opacity-30 disabled:cursor-not-allowed grid place-items-center transition-colors"
            aria-label="Adicionar ao carrinho"
          >
            <Plus className="w-4 h-4 text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};
